import { render } from "./Blog.vue?vue&type=template&id=4307aa45&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=4307aa45&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4307aa45"

export default script